import axios from "axios";
import { SETTINGS } from "../../Settings";
import store from "../../store/Store";
import { removeCurrentUser } from "../../store/AuthSlice";
import { useNavigate } from "react-router-dom";

export const AuthRepository = {
  fetchToken: (username, password, captchaToken) => {
    return axios({
      url: `${SETTINGS.EXTERNAL_API_URL}auth/authenticate`,
      method: "POST",
      data: {
        username: username,
        password: password,
        captchaToken: captchaToken,
      },
      withCredentials: true,
    });
  },

  logout: () => {
    store.dispatch(removeCurrentUser());
  },
};
